import { List } from "../Container/List/List";
import { Tag } from "../Tag";
import { RendererRegistry } from "./Renderer/RendererRegistry";

export class Form extends List {

    public getTagName(): string {
        return "form";
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addToData("_renderer", RendererRegistry.create(this.get("renderer") || "default"));
    }

    protected createByType(data: Map<any, any>, main: Tag): void {
        if (data.get("t") === "formi") {
            data.set("_renderer", this.get("_renderer"));
        }
        super.createByType(data, main);
    }
}
